import logo from './logo.svg';
import './App.css';
import logoImage from './images/logo.png'; // Update with your actual path
import videoSource from './images/WATRWELL_INTRO.mp4'; // Update with your actual path
import instaIcon from './images/insta.svg'; // Update with your actual path

function App() {
  return (
    <main className="homeMain">
      <section className="centerContent">
          <div className="container">
              <div className="wtrLogoArea">
                  <div className="watrLogo">
                      <h3>WATER HEALTH TECHNOLOGY</h3>
                  </div>

                  <div className="data">AN EMERGING GLOBAL INDUSTRY REDEFINING DRINKING WATER AS A PREVENTIVE HEALTH PLATFORM—INTEGRATING DESIGN, ENGINEERING, DATA, AND AUTOMATED, ON-DEMAND DISTRIBUTION TO EXPAND ACCESS, OPTIMIZE HUMAN HEALTH, AND REPLACE SINGLE-USE BOTTLED WATER WITH SMART, USER-FRIENDLY, SUSTAINABLE ECOSYSTEMS.</div>

                  <div className="data linkingFound mt-5 mb-5">PIONEERED BY <a href="https://watr.world/founder-letter/" target="_blank" rel="noopener noreferrer">ANTHONY BOLD</a>  + <a href="https://watr.world/link-with-us/" target="_blank" rel="noopener noreferrer"> WATR</a> </div>
                  <div className="logo">
                      <a href="#"><img src={logoImage}
                              className="img-fluid" width="50" alt="WATR Logo" /></a>
                  </div>
              </div>
          </div>
      </section>

      <section className="vdo">
          <video style={{width: '100%', height: 'auto', objectFit: 'cover'}} autoPlay loop muted playsInline>
              <source src={videoSource} type="video/mp4" />
          </video>
      </section>
      <footer>
        <div className="container">
          <div className="footerLinks">
            <div className="footerData">WATER HEALTH TECHNOLOGY © 2026</div>
            <a href="#" target="_blank"
              className="insta" rel="noopener noreferrer"><img src={instaIcon} className="img-fluid mainInsta" alt="Instagram" /></a>
            <div className="footerData">ALL RIGHTS RESERVED.</div>
          </div>
        </div>
      </footer>
    </main>
  );
}

export default App;